/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { useContext } from 'react';
import { WorkspaceActionCreator } from '/hooks/useWorkspaceState';
import { WorkspaceContext } from '/views/workspace/workspaceContext';
import { Dropdown } from 'components/dropdowns/dropdown';
import { ColorAliases, Variables as VARIABLES } from 'styles/variables';
import { DefaultChartColorScales } from 'styles/chartColors';

const colorOptions = Object.values(DefaultChartColorScales);

export const ColorSelector = ({ cardIndex, widgetConfiguration, activeItem, label, ...rest }) => {
	const { dispatch } = useContext(WorkspaceContext);

	const selectProperty = (value) => {
		const configuration = JSON.parse(JSON.stringify(widgetConfiguration));
		configuration.colorScale = value;
		dispatch(WorkspaceActionCreator.configuration(cardIndex, configuration));
	};

	return (
		<div>
			<span css={labelCss}>Color Using</span>
			<Dropdown
				activeItem={activeItem}
				onSelectionChanged={(value) => selectProperty(value)}
				options={widgetConfiguration?.availableColorScales || colorOptions}
				label="Color Using"
				css={dropDownCss}
				{...rest}
			/>
		</div>
	);
};

//To target the .popover-target would require popoverProps={{targetProps: {css : dropDownCss}}}. That doesn't work
//because it "stringifies" the dropDownCss prop. This way gets us around that.
const dropDownCss = css`
	& > span {
		width: 100%;
	}
`;

const labelCss = css`
	margin-bottom: 0;
	font-family: ${VARIABLES.PT_FONT_FAMILY};
	font-size: ${VARIABLES.PT_FONT_SIZE};
	color: ${ColorAliases.PT_HEADING_COLOR};
	font-weight: normal;
`;
